import React from 'react';
import { Link } from 'react-router-dom';
import { FaExpandArrowsAlt, FaBed, FaRulerCombined } from 'react-icons/fa';

// --- Helper Functions (bez zmian, ale warto je trzymać razem) ---

const capitalizeFirstLetter = (text) => {
    if (!text) return '';
    return text.charAt(0).toUpperCase() + text.slice(1);
};

const formatRoomsText = (numberOfRooms) => {
    if (numberOfRooms === 1) return 'pokój';
    if (numberOfRooms >= 2 && numberOfRooms <= 4) return 'pokoje';
    return 'pokoi';
};

const formatCurrency = (amount) => {
    const num = parseFloat(amount);
    if (isNaN(num)) return amount;
    return `${num.toLocaleString('pl-PL')} zł`; // Użycie toLocaleString dla lepszego formatowania
};

const formatNumber = (number) => {
    const num = parseFloat(number);
    if (isNaN(num)) return number;
    return num.toFixed(2).replace('.', ',');
};

// --- Mały, reużywalny komponent do wyświetlania detali ---
const DetailItem = ({ icon, children }) => (
    <div className="flex items-center text-sm text-gray-600 space-x-2">
        {icon}
        <span>{children}</span>
    </div>
);


const Card = ({ item }) => {
    // Bezpieczne pobranie pierwszego zdjęcia lub ustawienie placeholdera
    const imageSrc = item.zdjecia?.[0] || 'https://via.placeholder.com/400x300.png?text=Brak+zdjęcia';

    // Bezpieczne sprawdzenie typu nieruchomości
    const isPlot = item.typ_nieruchomosci?.trim().toLowerCase() === 'działka';

    return (
        // Cała karta jest linkiem, co poprawia użyteczność
        <Link to={`/listing/${item.id_ogloszenia}`} className="group block">
            <div className="flex flex-col h-full bg-white shadow-lg rounded-xl overflow-hidden border border-gray-200 transition-all duration-300 group-hover:shadow-xl group-hover:-translate-y-1">

                {/* --- SEKCJA ZDJĘCIA --- */}
                <div className="relative pt-[75%]"> {/* Proporcje 4:3 dla lepszego wyglądu */}
                    <picture>
                        <source srcSet={imageSrc.replace('.jpg', '.avif')} type="image/avif" />
                        <source srcSet={imageSrc.replace('.jpg', '.webp')} type="image/webp" />
                        <img
                            src={imageSrc}
                            alt={item.tytul}
                            className="absolute top-0 left-0 w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                            loading="lazy" // Leniwe ładowanie dla poprawy wydajności
                        />
                    </picture>
                    <div className="absolute top-3 right-3 bg-[#a07c5c] text-white text-xs font-semibold px-3 py-1 rounded-full">
                        {capitalizeFirstLetter(item.typ_nieruchomosci)}
                    </div>
                </div>

                {/* --- SEKCJA TREŚCI --- */}
                <div className="p-4 flex flex-col flex-grow">
                    {/* Lokalizacja */}
                    <h3 className="text-lg font-bold text-gray-800 truncate" title={item.miejscowosc_dzielnica}>
                        {item.miejscowosc_dzielnica}
                    </h3>
                    <p className="text-sm text-gray-500 mb-3 truncate" title={item.ulica}>
                        ul. {item.ulica}
                    </p>

                    {/* Cena - bardziej widoczna */}
                    <p className="text-2xl font-extrabold text-[#a07c5c] mb-4">
                        {formatCurrency(item.cena)}
                    </p>

                    {/* Detale - wspólne dla wszystkich typów */}
                    <div className="grid grid-cols-2 gap-3 mb-4">
                        <DetailItem icon={<FaExpandArrowsAlt className="text-gray-400" />}>
                            {formatNumber(item.powierzchnia)} m²
                        </DetailItem>

                        {/* Detale warunkowe */}
                        {isPlot ? (
                            item.wymiary_dzialki && (
                                <DetailItem icon={<FaRulerCombined className="text-gray-400" />}>
                                    {item.wymiary_dzialki}
                                </DetailItem>
                            )
                        ) : (
                            item.liczba_pokoi > 0 && (
                                <DetailItem icon={<FaBed className="text-gray-400" />}>
                                    {item.liczba_pokoi} {formatRoomsText(item.liczba_pokoi)}
                                </DetailItem>
                            )
                        )}
                    </div>

                    {/* Przycisk "Sprawdź" - przesunięty na dół */}
                    <div className="mt-auto pt-4 border-t border-gray-100 text-center">
                        <span className="font-bold text-[#a07c5c] group-hover:text-[#795b40] transition-colors">
                            Zobacz szczegóły
                        </span>
                    </div>
                </div>
            </div>
        </Link>
    );
};

export default Card;